import React from "react";
import { ArrowLeft } from "@phosphor-icons/react";
import "./css/CancellationsAndRefundsPage.css";
import { useNavigate } from "react-router-dom";

const CancellationsAndRefundsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="cancellations-page">

      <main className="cancellations-content">
        <button className="back-button" onClick={() => navigate(-1)}>
          <ArrowLeft size={24} weight="bold" />
          <span>Back</span>
        </button>

        <h1>Cancellations & Refunds</h1>

        <p>
          At <strong>Ravooka</strong>, we strive to provide our customers with
          the best products and services. However, we understand that there
          might be situations where you need to cancel or request a refund.
        </p>

        <h2>Order Cancellations</h2>
        <p>
          Orders can be cancelled before they are shipped. Once shipped, the
          order cannot be cancelled and will fall under our return policy.
        </p>

        <h2>Refunds</h2>
        <p>
          Refunds will be processed back to the original payment method within
          7–10 business days after the returned item is received and inspected.
        </p>

        <h2>Non-Refundable Items</h2>
        <ul>
          <li>Items marked as “Final Sale.”</li>
          <li>Custom or personalized orders.</li>
          <li>Gift cards.</li>
        </ul>

        <h2>Contact for Cancellations & Refunds</h2>
        <p>
          Email: <a href="mailto:support@ravooka.com">support@ravooka.com</a>
          <br />
          Phone: <a href="tel:+918904330936">+91 8904330936</a>
        </p>
      </main>
    </div>
  );
};

export default CancellationsAndRefundsPage;
